import { render, staticRenderFns } from "./textRound.vue?vue&type=template&id=4da4e34b&scoped=true&"
import script from "./textRound.vue?vue&type=script&lang=js&"
export * from "./textRound.vue?vue&type=script&lang=js&"
import style0 from "./textRound.vue?vue&type=style&index=0&id=4da4e34b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4e34b",
  null
  
)

export default component.exports